import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { TableTree } from "components/TableTree/TableTree";
import { useEffect, useState } from "react";
import { REPORT_URL } from "utils/constants";
import { ENDPOINTSREPORT } from "utils/endpoints";
import { getPrintTemplates , deletePrintTemplate, exportPrintTemplate, createMenu, syncPrintTemplates} from './api';
import { Toast } from "components/ToastShow/ToastAlert";

import { MessageType } from "types/enum";
import { trans } from "utils/helpers";
import { Toolbar } from "components/Toolbar/Toolbar";
import { getEnv } from "config/runtimeEnv";

export const PrintTemplates   = () => {
  const [data, setData] = useState<any>()
  const [forceUpdate, setForceUpdate] = useState(false)
  const [selectedObj, setSelectedObj] = useState<any>()
  const [loading, setLoading] = useState(false);
  const [messageType, setMessageType] = useState<any>("info");
  const [search, setsearch] = useState(null);
  const [idCallback, setIdCallback] = useState<any>("2")
  const [mode, setMode] = useState<any>(null)
  const [showForm, setShowForm] = useState<any>(null)
  const [filterPrintTemplateId, setFilterPrintTemplateId] = useState<any>(null);
  const [designType,setDesignType]=useState('')
  const [showImportPrintTemplateForm, setShowImportPrintTemplateForm] = useState(false)

  const clickToolbarCallback = (clickedButtonName: string) => {
    switch (clickedButtonName.toLowerCase()) {
      case "print":alert("print ");break;
      case "export": if (selectedObj && selectedObj.ParentId == null)exportAsync(selectedObj); break;
      case "refresh":setForceUpdate(!forceUpdate);break;
      case "create":setMode("create"); setShowForm(true);break;
      // case "design": if (selectedObj?.Id) handleDesignRow(); break;
      case "remove": if (selectedObj?.Id) Toast(trans("msg_deleteconfirm"), MessageType.confirmDelete , handleDeleteRow); break;
      case "edit": if (selectedObj?.Id) handleEditRow(); break;
      case "import": setShowImportPrintTemplateForm(true); break;
      case "createmenu":{handleCreateMenu()}break;
      case "sync":handleSyncAsync();break
    }
  };


const handleSyncAsync=async()=>{
try{
  await syncPrintTemplates()
}
catch(error){

}


}



  const handleCreateMenu=async()=>{
    setLoading(false)
    try{
    const res=  await createMenu(true)
    }
    catch(error){}
    setLoading(true)
  }

    async function exportAsync(obj) {
      try {
      const respons = await exportPrintTemplate(obj.Id)
     const contentDisposition = respons.headers['content-disposition'];
     let fileName = 'downloaded-file'; // Default filename
 
     if (contentDisposition) {
       const fileNameMatch:any = contentDisposition.match(/filename="(.+)"/);
       if (fileNameMatch.length > 1) {
         fileName = fileNameMatch[1];
       }
     }
     var pom = document.createElement('a');
     pom.setAttribute('href', window.URL.createObjectURL(respons.data));
     pom.setAttribute('download',obj.Name?obj.Name : fileName);
     pom.click();
      } catch (error) {
        setMessageType("error")
      }
  
    }
  const PrintTemplateDesignCallBack=(type)=>{
    if(selectedObj?.Id && (!selectedObj.IsDashboard)) handleDesignRow()
    setDesignType(type);
  if(selectedObj.IsDashboard){
    if(mode=="view"){
    window.open(`${getEnv("REACT_APP_PrintTemplateING_SERVICE_URL")+ "/DashboardViewer/View/"}${selectedObj?.Id }?userDataId=${sessionStorage.getItem("accept-data")} `,"_blank" );  
  }else{
    window.open(`${getEnv("REACT_APP_PrintTemplateING_SERVICE_URL")+ "/DashboardDesigner/Index/"}${selectedObj?.Id }?userDataId=${sessionStorage.getItem("accept-data")}&newVersion=${type=='FileWithNewVersion'?true:false}`,"_blank" );  
  }
  }
  }

  const handleDesignRow = () => {
    setFilterPrintTemplateId(selectedObj )
    //if(!selectedObj.IsPrintTemplate){
//
    //}else{
    ////  GetPrintTemplateWithJsonData(selectedObj.Id,null,0)
    //}
}
  const handleEditRow = () => {
    setMode("edit")
    setShowForm(true)

}

  const handleDeleteRow =async () => {
    try {
        await deletePrintTemplate(selectedObj.Id)
        setForceUpdate(!forceUpdate)
    } catch (error) {
        
    }

}

  async function getMenuAsync() {
    setLoading(false)
    try {
      const respons = await getPrintTemplates(null)
      setData(respons.Data)
    } catch (error) {
      setMessageType("error")
    }
    setLoading(true)

  }


  useEffect(() => {
    setData(null)
    getMenuAsync()
  }, [forceUpdate]);
  useEffect(() => {
    if(idCallback){
      setIdCallback(null)
    }
  }, [idCallback]);

  return (
    <>

{/* {
        filterPrintTemplateId &&
          <ModalForm mode={"edit"} title={trans("PrintTemplate")+" : " +filterPrintTemplateId?.Name}onHide={() => setFilterPrintTemplateId(null)} show={filterPrintTemplateId} modalHeight={60}>
              <FilterPrintTemplateForm designType={designType} Id={filterPrintTemplateId?.Id}  onHide={() => setFilterPrintTemplateId(null)} mode={"edit"} />
          </ModalForm>
      } */}
{/*       {
        showForm &&
          <ModalForm mode={mode} title="PrintTemplate" onHide={() => setShowForm(false)} show={showForm} modalHeight={60}>
              <WithFeedForm 
                onHide={() => setShowForm(false)}
                saveCallback={(e)=>{if(e.IsDashboard){     window.open(`${getEnv("REACT_APP_PrintTemplateING_SERVICE_URL")+ "/DashboardDesigner/Index/"}${selectedObj?.Id }?userDataId=${sessionStorage.getItem("accept-data")}&newVersion=${false}`,"_blank" );  
              }else{ setFilterPrintTemplateId(e )  ;setIdCallback(selectedObj.Id)} }}
                selectedObj={selectedObj} 
                mode={mode} 
              />
          </ModalForm>
      } */}

     {/*  {
        showImportPrintTemplateForm &&
        <ModalForm modalHeight={80} modalProfileKey={"Users"} title={"import"} onHide={() => setShowImportPrintTemplateForm(false)} show={showImportPrintTemplateForm}>
          <ImportPrintTemplateForm reload={()=>{ setShowImportPrintTemplateForm(false) ;setForceUpdate(!forceUpdate);}}  showForm={() => { setShowImportPrintTemplateForm(false) }} />
        </ModalForm>
      } */}
      <Toolbar /* sync={true} createMenu={true} */ /*  Export={selectedObj?.PrintTemplateTree?.length!=0} */  /* reportDesignCallBack={PrintTemplateDesignCallBack} */ excel={false} /* reportDesign={selectedObj&&selectedObj?.PrintTemplateTree==null} */ 
      createMenu={true} 
      create={true}  view={false} remove={(selectedObj&&selectedObj?.PrintTemplateTree==null)} edit={(selectedObj&&(selectedObj?.PrintTemplateTree==null && !selectedObj.IsPrintTemplate))} emptyList={data?.length == 0} id={selectedObj}   search={true}  handleClickToolbar={clickToolbarCallback} />
      <div style={{overflowY: "auto", 
          height: "72vh",
           scrollbarWidth: "thin"}} className="col-lg-12 mt-3 ">
        <div className="list-card card ">
            
          {
            loading ? (
              data ?
              <>    
                <TableTree
                  search={search}
                  maxLevel={1}
                  params={"Scope"}
                  IdParams={"Scope"}
                  Childrenparams={"ReportTree"}
                  Titleparams={"Name"}
                  selectedRowObjectCallback={setSelectedObj}
                  selectedRowObject={idCallback}
                  Data={data}
                  theadData={Object.keys(data[0])}
                  parentName={"PrintTemplates "}
                  startIndex={4}
                  getChildrenUrl={ENDPOINTSREPORT.Report.printTree}
                  baseUrl={REPORT_URL}

                  />
                  </>
                 : <Message message={"NoDataForPreview"} type={messageType} />)

              : <Loading />
          }
        </div>
      </div>
    </>
  )
}